/**
 * URL utilities
 */

/**
 * Normalize a base URL by removing trailing slash
 */
export function normalizeUrl(url: string): string {
  return url.endsWith('/') ? url.slice(0, -1) : url;
}

/**
 * Join URL parts, handling trailing/leading slashes correctly
 */
export function joinUrl(base: string, path: string): string {
  const normalizedBase = normalizeUrl(base);
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
}
